import styled from '../../utils/styled'

export const TabContainer = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
`

export const Tab = styled.button<{ active: boolean }>`
  flex: 1;
  padding: 0.5rem 1rem;
  color: ${({ active, theme }) => (active ? theme.colors.body : theme.colors.body2)};
  background-color: transparent;
  border: none;
  border-bottom-width: 1px;
  border-bottom-style: solid;
  border-bottom-color: ${({ active, theme }) => (active ? theme.colors.black : theme.colors.borders)};
`
